import React__default from 'react';
import classnames from 'classnames';
import { SelectionBoxRadio, RichTextArea } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';

const RxEntryRadioTile = ({ className , value , title , description , iconName , isSelected , onChange ,  })=>{
    return /*#__PURE__*/ React__default.createElement(SelectionBoxRadio, {
        className: classnames('rx-entry-radio-tile', className),
        name: "rx-entry-radio-tile",
        value: value,
        checked: isSelected,
        onChange: ()=>onChange(value)
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "rx-entry-radio-tile__wrapper"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "rx-entry-radio-tile__image"
    }), /*#__PURE__*/ React__default.createElement("div", {
        className: "rx-entry-radio-tile__body"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "rx-entry-radio-tile__heading"
    }, iconName && /*#__PURE__*/ React__default.createElement(Icon, {
        className: "rx-entry-radio-tile__icon",
        name: iconName
    }), /*#__PURE__*/ React__default.createElement(Heading, {
        className: "rx-entry-radio-tile__title",
        component: "div",
        variant: "subheading1",
        visualHeadingOnly: true
    }, title)), description && /*#__PURE__*/ React__default.createElement(RichTextArea, {
        className: "rx-entry-radio-tile__description",
        content: description
    }))));
};

export { RxEntryRadioTile };
//# sourceMappingURL=RxEntryRadioTile.js.map
